import {CLIENTS} from '../../actions/clients/clientsActionTypes';

const INITIAL_STATE = {
  clientsLoading: true,
  clients: [],

  companiesClientsList: [],
  companiesClientsListLoading: true,

  companiesClients: {},
  companiesClientsLoading: true,

  companiesClientsPopup: [],
  companiesClientsPopupLoading: true
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case CLIENTS.GET_CLIENTS_SUCCESS:
      return {...state, clients: action.payload.data.data, clientsLoading: false};
    case CLIENTS.GET_CLIENTS_FAIL:
      return {...state, clients: [], clientsLoading: false};

    case CLIENTS.GET_COMPANY_CLIENTS_LIST_SUCCESS:
      return {...state, companiesClientsList: action.payload.data.data, companiesClientsListLoading: false};
    case CLIENTS.GET_COMPANY_CLIENTS_LIST_FAIL:
      return {...state, companiesClientsList: [], companiesClientsListLoading: false};

    case CLIENTS.GET_COMPANY_CLIENTS_POPUP:
      return {...state, companiesClientsPopup: [], companiesClientsPopupLoading: true};
    case CLIENTS.GET_COMPANY_CLIENTS_POPUP_SUCCESS:
      return {...state, companiesClientsPopup: action.payload.data.data, companiesClientsPopupLoading: false};
    case CLIENTS.GET_COMPANY_CLIENTS_POPUP_FAIL:
      return {...state, companiesClientsPopup: [], companiesClientsPopupLoading: false};
    case CLIENTS.GET_COMPANY_CLIENTS:
      return {...state, companiesClients: {}, companiesClientsLoading: true};
    case CLIENTS.GET_COMPANY_CLIENTS_SUCCESS:
      return {...state, companiesClients: action.payload.data.data, companiesClientsLoading: false};
    case CLIENTS.GET_COMPANY_CLIENTS_FAIL:
      return {...state, companiesClients: {}, companiesClientsLoading: true};

    case CLIENTS.CLEAR_CLIENTS:
      return {
        ...state,
        companiesClientsList: [],
        companiesClients: {},
        companiesClientsListLoading: true,
        companiesClientsLoading: true
      };
    default:
      return state;
  }
}
